import {
  ACCOMPLISHMENT,
  AFFILIATION,
  CERTIFICATION,
  SKILL,
  SUMMARY,
  WORK_EXPERIENCE,
} from '@glass/common/modules/content/deprecatedContentTypes';

import accomplishmentsQuery from '@glass/shared/modules/content/staticVariations/queries/accomplishments.graphql';
import affiliationsQuery from '@glass/shared/modules/content/staticVariations/queries/affiliations.graphql';
import certificationsQuery from '@glass/shared/modules/content/staticVariations/queries/certifications.graphql';
import skillsQuery from '@glass/shared/modules/content/staticVariations/queries/skills.graphql';
import summariesQuery from '@glass/shared/modules/content/staticVariations/queries/summaries.graphql';
import workExperiencesQuery from '@glass/shared/modules/content/staticVariations/queries/workExperiences.graphql';

const resourceQueries = {
  [ACCOMPLISHMENT]: {
    query: accomplishmentsQuery,
    dataKey: 'accomplishments',
  },
  [AFFILIATION]: {
    query: affiliationsQuery,
    dataKey: 'affiliations',
  },
  [CERTIFICATION]: {
    query: certificationsQuery,
    dataKey: 'certifications',
  },
  [SKILL]: {
    query: skillsQuery,
    dataKey: 'skills',
  },
  [SUMMARY]: {
    query: summariesQuery,
    dataKey: 'summaries',
  },
  [WORK_EXPERIENCE]: {
    query: workExperiencesQuery,
    dataKey: 'workExperiences',
  },
};

export default resourceQueries;
